import styled from 'react-emotion'
import deferComponentRender from 'util/deferRenderHOC'
import SkinnedEditor from './Skinned'

/* This is a little brittle. We have to pick the right placeholder height to
 * avoid jumpiness when the deferred component renders.
 */
const LoadingPlaceholder = styled('div')`
  height: ${props => props.placeholderHeight || 60}px;
`

export default deferComponentRender(SkinnedEditor, LoadingPlaceholder)
